import { GIG_GRID_LRG, GIG_GRID_MED, GIG_GRID_SML, GIG_GRID_XLRG } from '../Grid';

export const getSliderConfig = (boxLocation) => {
    // slightly different settings depending on whether the
    // gig card carousel is at the bottom (using the full page width)
    // or inside the main content column

    let sliderBaseNum = 2;
    let sliderBreakpoints = [
        {
            breakpoint: GIG_GRID_LRG,
            slides: 3
        },
        {
            breakpoint: GIG_GRID_MED,
            slides: 2
        },
        {
            breakpoint: GIG_GRID_SML,
            slides: 1
        }
    ];

    if (boxLocation === 'bottom') {

        sliderBaseNum = 5;
        sliderBreakpoints = [
            {
                breakpoint: GIG_GRID_XLRG,
                slides: 3
            },
            {
                breakpoint: GIG_GRID_LRG,
                slides: 3
            },
            {
                breakpoint: GIG_GRID_MED,
                slides: 2
            },
            {
                breakpoint: GIG_GRID_SML,
                slides: 1
            }
        ];

    }

    return {
        sliderBaseNum,
        sliderBreakpoints
    };
};
